<template>
    <div class="column is-12" >
        <div v-for="(evento,index) in eventos" :key="index"
            :class="tipoEventoStyle(evento)"  >
            <div class="column is-2 has-text-centered">
                <b :class="{ 'is-size-7  is-paddingless' : (tipoVisao=='mes') , 'is-size-6 is-paddingless':  (tipoVisao=='dia') }" >{{evento.hour}}</b>
                <b-icon v-if="evento.tipoAgendamentoCor"
                        :style="tipoAgendamentoStyle(evento)"    
                        size="is-small"                                            
                        icon="square-rounded"></b-icon>
                <b v-if="!isBloqueio(evento) && isAgendado(evento) && !isConfirmado(evento)" :title="$t('AGENDA.PACIENTENAOCONFIRMADO')" class="has-text-danger">!</b> 
                <b v-if="!isBloqueio(evento) && isAgendado(evento) && isConfirmado(evento)" :title="$t('AGENDA.PACIENTECONFIRMADO')" class="has-text-success">&radic;</b> 
                                       
            </div>
            <div class="column is-10" style="margin-left: 5px;">

                <span class="is-pulled-right">

                    <b-button class="is-pulled-right" position="is-bottom-left"  v-show="!isBloqueio(evento) && !isAgendado(evento) && !agendaWorklist"   :title="$t('AGENDA.BLOQUEARHORARIO')" 
                        icon-left="cancel" type="is-black"   @click="bloquearHorario(evento)" ></b-button>                                                          
                    <b-button class="is-pulled-right" position="is-bottom-left" v-show="isBloqueio(evento) && !agendaWorklist"  
                        :title="$t('AGENDA.DESBLOQUEARHORARIO')" icon-left="lock-open"  @click="desbloquearHorario(evento.id) && !agendaWorklist"   ></b-button> 
                    <b-button class="is-pulled-right" position="is-bottom-left" v-show="!isBloqueio(evento) && !isAgendado(evento)" :title="$t('AGENDA.INCLUIRPACIENTE')"  
                        icon-left="account-plus" @click="incluirNovoHorarioDia(evento, evento.dataHora)"></b-button>                                

                    <b-dropdown
                        v-show="isAgendado(evento)"
                        append-to-body                    
                        position="is-bottom-left"                        
                        aria-role="list"
                        trap-focus >
                        <template #trigger="{ active }">
                            <b-button tag="a" :icon-right="tipoIcone(active)" />                        
                        </template>

                    <b-dropdown-item aria-role="listitem"   @click="criarGuia(evento)">{{$t('AGENDA.CRIARGUIA')}} </b-dropdown-item>                        
                    <b-dropdown-item aria-role="listitem"  @click="verGuiasPaciente(evento)">{{$t('AGENDA.VERGUIAPACIENTE')}} </b-dropdown-item>
                    <b-dropdown-item aria-role="listitem"   @click="incluirNovoHorarioDia(evento, evento.dataHora)">Editar </b-dropdown-item>
                    <b-dropdown-item aria-role="listitem" v-if="!isConfirmado(evento)"  @click="confirmarPaciente(evento)">Confirmar </b-dropdown-item>
                    <b-dropdown-item aria-role="listitem"  @click="confirmarCancelamento(evento)">Cancelar </b-dropdown-item>                    
                    <hr class="dropdown-divider" aria-role="menuitem">                    
                    <b-dropdown-item aria-role="listitem"  @click="abrirImprimir(evento)"><b-icon  icon="printer" ></b-icon>Imprimir </b-dropdown-item>
                    <hr class="dropdown-divider" aria-role="menuitem">                    
                    <b-dropdown-item aria-role="listitem"  @click="exibirHistorico(evento)"><b-icon  icon="clock" ></b-icon>Histórico </b-dropdown-item>                    
                    
                    
                </b-dropdown>                               

                </span>
                             
                <p  :class="{ 'is-size-7 text-nowrap' : (tipoVisao=='mes') , 'is-size-5':  (tipoVisao=='dia') }" >{{tratarNomePaciente(evento)}}</p>
                <p v-if="evento.pacienteResponsavelNome"  :class="{ 'is-size-7 text-nowrap' : (tipoVisao=='mes') , 'is-size-5':  (tipoVisao=='dia') }">
                    <b>{{tratarNome(evento.pacienteResponsavelNome)}}</b>
                </p>
                <p :class="{ 'is-size-7 text-nowrap' : (tipoVisao=='mes') , 'is-size-5':  (tipoVisao=='dia') }">
                    <i>{{tratarNome(evento.tipoAgendamentoNome)}}</i>
                </p>
              
                
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    
    .text-nowrap{
        text-overflow: ellipsis;
        white-space: nowrap;        
        overflow: hidden;        
        max-width: 10rem;  
    }
  

</style>

<script>

import moment from 'moment';
import historicoAlteracoes from "@/components/historicoAlteracoes.vue";

export default {
    props: {
        eventos: Array,
        tipoVisao: String,
        agendaWorklist: {
            type: Boolean,
            default: false
        }               
    },
    methods: {

        exibirHistorico(item) {
            this.$buefy.modal.open({
                parent: this,
                component: historicoAlteracoes,
                props: {
                    tabela: '',
                    chave: item.id,
                    toggle: true,
                    agendaLog: true,
                },
                hasModalCard: true,
                trapFocus: true
            })
        },          
        tipoIcone(active){
            
            if(this.tipoVisao =="mes"){
                return active ? 'menu-up' : 'menu-down';
            }else{
                return 'format-list-bulleted';
            }

        },
        tipoAgendamentoStyle(evento) {
            return 'color: #' + evento.tipoAgendamentoCor + '!important'
        },
        tipoEventoStyle(evento) {
            let classes = 'box columns is-mobile is-gapless is-paddingless';
            
            if(this.isBloqueio(evento))
                classes += ' has-text-light has-background-dark';

            if(this.isAgendado(evento) && this.tipoVisao=="dia")
                classes += ' has-background-info has-text-light';
                
            return classes;                

        },    
  
        tratarNomePaciente(evento){

            if(evento.pacienteNome){
                return evento.pacienteNome.toLowerCase();
            }else if(evento.id>0 && !evento.pacienteNome){
                return this.$t('AGENDA.HORARIOBLOQUEADO');
            }
            
        },
        tratarNome(nome){            
            if(!nome){
                return null;
            }
            return nome.toLowerCase();                        
        },
        
        isBloqueio(evento){              
            
            return (evento.id && !evento.pacienteNome && evento.observacao=='Bloqueio');                
        }, 
        isAgendado(evento){              
            
            return (evento.pacienteNome);                
        },  
        isConfirmado(evento){              
            
            return (evento.pacienteConfirmado);                
        },          
        desbloquearHorario(id){                
            const evento = {id: id};
            this.agendaStatus(evento, 'cancelar');
        },            
        bloquearHorario(evento){            
            const bloqueio = {
                data: evento.dataHora,
                observacao: 'Bloqueio',
                idPaciente: 0,
                idTipoAgendamento: evento.tipoAgendamentoId,
                funcionarioId: null,
                paciente: { id: 0 },
                tipoAgendamento: { id: evento.tipoAgendamentoId},
            }

            this.adicionarAgendamento(bloqueio);
        }, 
        confirmarPaciente(evento){
            this.$buefy.dialog.confirm({
                title: 'Confirmar',
                message: this.$t('AGENDA.CONFIRMAPACIENTE'),
                type: 'is-info',
                hasIcon: true,
                cancelText: 'Não',
                confirmText: 'Sim',
                onConfirm: () => {
                    this.agendaStatus(evento,'confirmar')
                }
            })
        },                   
        confirmarCancelamento(evento){
            this.$buefy.dialog.confirm({
                title: 'Cancelar',
                message: this.$t('AGENDA.CONFIRMACANCELAMENTO'),
                type: 'is-danger',
                hasIcon: true,
                cancelText: 'Não',
                confirmText: 'Sim',
                onConfirm: () => {
                    this.agendaStatus(evento,'cancelar')
                }
            })
        },    
         criarGuia(evento){
            this.$router.push({
                name: 'novaguia', params: {
                    agendamento: evento.id,
                    pacienteId: evento.pacienteId,
                    tipoAgendamentoid: evento.tipoAgendamentoId,
                    tipoAgendamentoNome: evento.tipoAgendamentoNome
                    
                }
            })             
         },   
         verGuiasPaciente(evento){
             this.$router.push({ name: 'guia-list', query: { pacienteId: evento.pacienteId } })
         },
         abrirImprimir(evento){            
            this.$emit("abrirImprimir", { id: evento.id });
         },
         incluirNovoHorarioDia(evento,dataHora){             
            this.$emit("incluirNovoHorarioDia", evento,dataHora);
         },
        async agendaStatus(evento,acao) {
            const params = [];
            if (evento.id) params.push(`id=${evento.id}`);

            params.push(`acao=${acao}`);

            try {
                const url = `/api/atendimento/AgendaStatus?${params.join('&')}`;
                const res = await this.$http.get(url);
                this.$emit('loadData')
            } catch (e) {
                console.error(e);
            }

        },

        async adicionarAgendamento(evento) {
            const params = [];
            if (evento.id) params.push(`id=${evento.id}`);
            params.push(`pacienteId=${evento.paciente.id}`);
            params.push(`tipoAgendamentoId=${evento.tipoAgendamento.id}`);
            if(evento.funcionarioId == null) evento.funcionarioId = 0;
            params.push(`funcionarioId=${evento.funcionarioId}`);
            params.push(`datahora=${moment(evento.data).format('YYYY-MM-DDTHH:mm:ss')}`);
            params.push(`observacao=${evento.observacao ? evento.observacao : ''}`);
            if (this.$route.query.unidadeId != null)
                params.push(`unidadeId=${this.$route.query.unidadeId}`)
            else
                params.push('unidadeid=');

            try {
                let url = `/api/atendimento/agendaincluir?${params.join('&')}`;

                if (evento.id) {
                    url = `/api/atendimento/agendaEditar?${params.join('&')}`;
                }

                this.isLoading = true;
                const res = await this.$http.post(url);                    
                this.$emit('loadData')
            } catch (e) {                    
                if (e.status === 404) {
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: this.$t('AGENDA.ERROAOSALVAR'),
                        type: 'is-danger',
                        queue: false
                    })
                }
                console.error(e);
                
            }

        },                          
                
    }
};
</script>